// extracted by mini-css-extract-plugin
module.exports = {"main":"section-custom-bg_main__4tlXr"};